import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Apollo } from 'apollo-angular';
import { AbstractService } from './abstract-service';
import { map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class EnumService extends AbstractService {

    private cache: { [type: string]: any[] } = {};

    constructor(apollo: Apollo) {
        super(apollo, 'common', 'enum');
    }

    public getEnumByType(type: string): Observable<string[]> {
        const cacheEntries = this.cache[type];
        if (cacheEntries) {
            return of(cacheEntries);
        }
        return this
            .query(type)
            .pipe(
                map(result => result.data[this.domainName][this.entityName][type]),
                map(items => items as string[]),
                tap(items => this.cache[type] = items)
            );
    }
}
